var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "doctor-restrictions",
      attrs: { "data-qa": "lpu_doctors_list_restrictions" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "doctor-restrictions__body d-flex align-start rounded-sm",
        },
        [
          _c("span", {
            staticClass: "doctor-restrictions__icon ui-icon-circle-warning",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "py-2 pr-4" }, [
            _c("div", { staticClass: "text-body-2 text--text mb-1" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _setup.tStatic(
                      "Ознакомьтесь с ограничениями на приём у врача в этой клинике"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "text-link-2 cursor-pointer primary--text link-decoration-underline pa-0",
                attrs: {
                  type: "button",
                  "data-qa": "lpu_doctors_list_restrictions_open",
                },
                on: {
                  click: function ($event) {
                    _setup.isRestrictionsOpen = true
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_setup.tStatic("Смотреть")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(_setup.DoctorAppointmentRestrictionsModal, {
        attrs: {
          "doctor-id": _vm.doctorId,
          "lpu-id": _vm.lpu.id,
          "lpu-name": _setup.lpuName,
        },
        model: {
          value: _setup.isRestrictionsOpen,
          callback: function ($$v) {
            _setup.isRestrictionsOpen = $$v
          },
          expression: "isRestrictionsOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }